import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import ErrorBoundary from "./components/ErrorBoundary";
import { store } from "./store/store";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "typeface-roboto";
import { ThemeProvider } from "@material-ui/core";
import { customTheme } from "./style/customTheme";

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary>
      <ThemeProvider theme={customTheme}>
        <App />
      </ThemeProvider>
    </ErrorBoundary>
  </Provider>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
